var render = function render(){var _vm=this,_c=_vm._self._c;return _c('company-layout',[_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('users-index')],1),_vm._v(" "),_c('v-col',{staticClass:"mt-5",attrs:{"cols":"12"}},[_c('roles-index')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }